import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import { DocsService } from 'src/app/services/docs.service';

export type OnOffOption = '0' | '1';
export type Fit = 'fit' | 'fitH' | 'fitV';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class PdfViewerComponent implements OnInit {

  public media;
  public dataLoaded: boolean = false;
  public loadError: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private docService: DocsService,
  ) { }

  private _docId: string;
  @Input() set documentId(id: string) {
    this._docId = id;
  }
  private _blob: any;
  @Input() set blob(blob: any) {
    this._blob = blob;
  }

  private _toolbar: OnOffOption = '1';
  @Input() set toolbar(option: OnOffOption) {
    this._toolbar = option;
  }

  private _navpanes: OnOffOption = '0';
  @Input() set navpanes(option: OnOffOption) {
    this._navpanes = option;
  }

  private _page: number;
  @Input() set page(page: number) {
    this._page = page;
  }

  private _fit: Fit = 'fit';
  @Input() set fit(fit: Fit) {
    this._fit = fit;
  }

  private _zoom: string = null;
    @Input() set zoom(scale: string) {
        var reload: boolean = this._zoom != null && this.zoom != scale;
        this._zoom = scale;
        if (reload) this.load();
        console.log(reload);
    }

    ngOnInit(): void {
        this.load();
    }

    private displayPDF(base64: string): void {
      let url = `${base64}#toolbar=${this._toolbar}&navpanes=${this._navpanes}&page=${this._page}`;
      url = !!this._zoom ? `${url}&zoom=${this._zoom}` : `${url}&view=${this._fit}`;
    
      this.media = this.sanitizer.bypassSecurityTrustHtml(
        `<embed src="${url}" type="application/pdf" width="100%" height="100%" />`
      );
      this.dataLoaded = true;
    }
    
    private displayImage(base64: string): void {
      this.media = this.sanitizer.bypassSecurityTrustHtml(
        `<img src="${base64}" alt="Uploaded Image" style="width: 100%; height: auto;" />`
      );
      this.dataLoaded = true;
    }
    
    private displayBlob(blob: Blob): void {
      const data = URL.createObjectURL(blob);
      let url = `${data}#toolbar=${this._toolbar}&navpanes=${this._navpanes}&page=${this._page}`;
      url = !!this._zoom ? `${url}&zoom=${this._zoom}` : `${url}&view=${this._fit}`;
    
      if (blob.type.startsWith("application/pdf")) {
        this.displayPDF(url);
      } else if (blob.type.startsWith("image/")) {
        this.displayImage(data);
      } else {
        console.error("Unsupported Blob type.");
      }
    }
    


    public load(): void {
      if (this._docId) {
        // Fetch PDF from API if documentId is present
        this.docService.getPdfMedia(this._docId).subscribe(
          (blob) => {
            const data = URL.createObjectURL(blob);
            let url = `${data}#toolbar=${this._toolbar}&navpanes=${this._navpanes}&page=${this._page}`;
            url = !!this._zoom ? `${url}&zoom=${this._zoom}` : `${url}&view=${this._fit}`;
    
            this.media = this.sanitizer.bypassSecurityTrustHtml(
              `<embed src="${url}" type="application/pdf" width="100%" height="100%" />`
            );
            this.dataLoaded = true;
          },
          (err) => {
            this.loadError = true;
            console.error("Error fetching document:", err);
          }
        );
      } 
      else if (this._blob) {
        if (typeof this._blob === "string") {
          if (this._blob.startsWith("data:application/pdf;base64,")) {
            // PDF Base64
            this.displayPDF(this._blob);
          } else if (this._blob.startsWith("data:image/")) {
            // Image Base64 (JPG, PNG, etc.)
            this.displayImage(this._blob);
          } else {
            console.error("Unsupported Base64 format.");
          }
        } 
        else if (this._blob instanceof Blob) {
          this.displayBlob(this._blob);
        } 
        else {
          console.error("Invalid _blob type.");
        }
      } 
      else {
        console.error("No documentId or _blob available.");
      }
    }
    
    

}
